interface GetNpcInboundFreightShippingAction {
  type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_SHIPPING;
  payload: any;
}

interface GetNpcInboundFreightParamsAction {
  type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_PARAMS;
  payload: any;
}

interface GetNpcInboundFreightBrandsAction {
  type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_BRANDS;
  payload: any;
}

interface GetNpcInboundFreightBrandAction {
  type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_BRAND;
  payload: any;
}

interface GetNpcInboundFreightMinDateAction {
  type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_MINDATE;
  payload: string;
}

interface GetNpcInboundFreightBrandItemsAction {
  type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_BRAND_ITEMS;
  payload: any;
}

interface GetNpcInboundFreightAnalyticsAction {
  type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_ANALYTICS;
  payload: any;
}

interface GetNpcIetNpcInboundFreightPOAction {
  type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_PO;
  payload: any;
}

interface SetNpcInboundFreightShippingLoadingAction {
  type: NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_SHIPPING_LOADING;
}

interface SetNpcInboundFreightBrandsLoadingAction {
  type: NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_BRANDS_LOADING;
}

interface SetNpcInboundFreightBrandLoadingAction {
  type: NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_BRAND_LOADING;
}

interface SetNpcInboundFreightBrandItemsLoadingAction {
  type: NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_BRAND_ITEMS_LOADING;
}

interface SetNpcInboundFreightAnalyticsLoadingAction {
  type: NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_ANALYTICS_LOADING;
}

interface SetNpcInboundFreightPOLoadingAction {
  type: NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_PO_LOADING;
}

interface ClearNpcInboundFreightAction {
  type: NpcInboundFreightActionTypes.CLEAR_NPC_INBOUND_FREIGHT;
}

export enum NpcInboundFreightActionTypes {
  GET_NPC_INBOUND_FREIGHT_SHIPPING = 'GET_NPC_INBOUND_FREIGHT_SHIPPING',
  GET_NPC_INBOUND_FREIGHT_PARAMS = 'GET_NPC_INBOUND_FREIGHT_PARAMS',
  GET_NPC_INBOUND_FREIGHT_BRANDS = 'GET_NPC_INBOUND_FREIGHT_BRANDS',
  GET_NPC_INBOUND_FREIGHT_BRAND = 'GET_NPC_INBOUND_FREIGHT_BRAND',
  GET_NPC_INBOUND_FREIGHT_MINDATE = 'GET_NPC_INBOUND_FREIGHT_MINDATE',
  GET_NPC_INBOUND_FREIGHT_BRAND_ITEMS = 'GET_NPC_INBOUND_FREIGHT_BRAND_ITEMS',
  GET_NPC_INBOUND_FREIGHT_ANALYTICS = 'GET_NPC_INBOUND_FREIGHT_ANALYTICS',
  GET_NPC_INBOUND_FREIGHT_PO = 'GET_NPC_INBOUND_FREIGHT_PO',
  SET_NPC_INBOUND_FREIGHT_SHIPPING_LOADING = 'SET_NPC_INBOUND_FREIGHT_SHIPPING_LOADING',
  SET_NPC_INBOUND_FREIGHT_BRANDS_LOADING = 'SET_NPC_INBOUND_FREIGHT_BRANDS_LOADING',
  SET_NPC_INBOUND_FREIGHT_BRAND_LOADING = 'SET_NPC_INBOUND_FREIGHT_BRAND_LOADING',
  SET_NPC_INBOUND_FREIGHT_BRAND_ITEMS_LOADING = 'SET_NPC_INBOUND_FREIGHT_BRAND_ITEMS_LOADING',
  SET_NPC_INBOUND_FREIGHT_ANALYTICS_LOADING = 'SET_NPC_INBOUND_FREIGHT_ANALYTICS_LOADING',
  SET_NPC_INBOUND_FREIGHT_PO_LOADING = 'SET_NPC_INBOUND_FREIGHT_PO_LOADING',
  CLEAR_NPC_INBOUND_FREIGHT = 'CLEAR_NPC_INBOUND_FREIGHT',
}

export interface NpcInboundFreightState {
  shipping: {
    qtyShipped: number;
    amount: number;
    averageAmount: number;
    total_chart: any[];
    shipping_brand: any[];
  };
  brands: {
    table: any[];
    chart: any[];
    total: any;
  };
  brand: {
    table: any[];
    items_table: any[];
    total: any;
  };
  lists: {
    brands: any[];
    categories: any[];
    sizes: any[];
  };
  analytics: any[];
  po: any[];
  min_date: string | null;
  loading_lists: boolean;
  loading_brand: boolean;
  loading_brands: boolean;
  loading_shipping: boolean;
  loading_analytics: boolean;
  loading_po: boolean;
}

export type NpcInboundFreightAction =
  | ClearNpcInboundFreightAction
  | GetNpcInboundFreightShippingAction
  | GetNpcInboundFreightParamsAction
  | GetNpcInboundFreightBrandsAction
  | GetNpcInboundFreightBrandAction
  | GetNpcInboundFreightMinDateAction
  | GetNpcInboundFreightBrandItemsAction
  | GetNpcInboundFreightAnalyticsAction
  | GetNpcIetNpcInboundFreightPOAction
  | SetNpcInboundFreightShippingLoadingAction
  | SetNpcInboundFreightBrandsLoadingAction
  | SetNpcInboundFreightBrandLoadingAction
  | SetNpcInboundFreightBrandItemsLoadingAction
  | SetNpcInboundFreightAnalyticsLoadingAction
  | SetNpcInboundFreightPOLoadingAction;
